import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

class Footer_v2 extends Component {

	componentDidMount() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		const minscript = document.createElement("script");
		minscript.async = true;
		minscript.src = publicUrl + "assets/js/main.js";

		document.body.appendChild(minscript);
	}

	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'
		let imgattr = "Footer logo"

		return (
			<footer className="footer-area footer-area-2 bg-gray">
				<div className="footer-top">
					<div className="container">
						<div className="row">
							<div className="col-lg-3 col-md-6">
								<ScrollAnimation animateIn="bounceIn">
									<div className="widget widget_about text-center">
										<a href="index.html"><img src={publicUrl + "assets/img/website/logoMIET.png"} alt="img" /></a>
										<div className="details">
											<p>The ‘Madras Institute of Engineering Technology’ (M.I.E.T.) was established in the year 1989 which is a unit of Vinayaka Trust.</p>
											<ul className="social-media">
												<li><a href="https://www.facebook.com/mietchennai1960/" target="_blank"><i className="fa fa-facebook" /></a></li>
												<li><a href="https://www.linkedin.com/company/mieteducation" target="_blank"><i className="fa fa-linkedin" /></a></li>
												<li><a href="https://www.instagram.com/miet_chennai/" target="_blank"><i className="fa fa-instagram" /></a></li>
												<li><a href="https://www.youtube.com/channel/UC3-7aQOlIX6lcMwfzCZ_xrw" target="_blank"><i className="fa fa-youtube" /></a></li>
											</ul>
										</div>
									</div>
								</ScrollAnimation>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="widget widget_contact">
									<h4 className="widget-title">Contact Us</h4>
									<ul className="details">
									<li style={{ textAlign: 'left' }}>
  <i className="fa fa-map-marker" /> 
  <b>MIET</b> No. 385, Arcot Road, <br /> 
  Adj. Liberty Flyover, Kodambakkam, <br /> 
  Chennai - 600024. <br />
  <a 
    href="https://www.google.com/maps?q=MIET+No.+385,+Arcot+Road,+Kodambakkam,+Chennai+600024" 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'blue' }}
  >
    View on Google Maps
  </a>
</li>

										<li>
  <i className="fa fa-envelope" /> 
  <a href="mailto:tmgunaraja@gmail.com">tmgunaraja@gmail.com</a>
</li>

										<li>
  <i className="fa fa-phone" /> 
  <a href="tel:+919962924444">+91 99629 24444</a> /<br />
  <a href="tel:+919962126120">99621 26120</a>
</li>

									</ul>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="widget widget_nav_menu">
									<h4 className="widget-title">Quick Link</h4>
									<ul className="go-top fooul">
										<li className='fooli'><Link to="/about">About</Link></li>
										<li className='fooli'><Link to="/administration">Administration </Link></li>
										<li className='fooli'><Link to="/gallery">Gallery </Link></li>
										<li className='fooli'><Link to="/contact">Contact Us</Link></li>
									</ul>
								</div>
								<div className="widget widget_nav_menu">
									<h4 className="widget-title">Academics</h4>
									<ul className="go-top fooul">
										<li className='fooli'><Link to="/ncvt-course">NCVT Courses</Link></li>
										<li className='fooli'><Link to="/industrial-school-courses">Industrial School Courses</Link></li>
										<li className='fooli'><Link to="/neet-courses-in-chennai">NEET</Link></li>
										<li className='fooli'><Link to="/jee-courses-in-chennai">JEE</Link></li>
										<li className='fooli'><Link to="/nata-courses-in-chennai">NATA</Link></li>
										<li className='fooli'><Link to="/tmg-college-of-arts-and-science">TMG College of Arts & Science</Link></li>
										<li className='fooli'><Link to="/university-of-madras">University of Madras</Link></li>
										<li className='fooli'><Link to="/bharathidasan-university">Bharathidasan University</Link></li>
										<li className='fooli'><Link to="/tamilnadu-open-university">Tamil Nadu Open University</Link></li>
										<li className='fooli'><Link to="/data-science-and-artificial-intelligence-courses">Data Science & AI</Link></li>
										<li className='fooli'><Link to="/school-courses">Classes IX, X, XI, XII</Link></li>
										<li className='fooli'><Link to="/nra-cet-courses-in-chennai">NRA CET</Link></li>
										<li className='fooli'><Link to="/hotel-management-courses-in-chennai">Courses (Degree/Diploma/Craft)</Link></li>
										<li className='fooli'><Link to="/gate-coaching-centre-in-chennai">GATE</Link></li>
										<li className='fooli'><Link to="/ugc-net-coaching-centre-in-chennai">NET</Link></li>
										<li className='fooli'><Link to="/slet-coaching-centre-in-chennai">SLET</Link></li>
										<li className='fooli'><Link to="/ies-training-institute-chennai">IES</Link></li>
										<li className='fooli'><Link to="/engineering-and-architecture-guidance-program">Engineering & Architecture Guidance Program</Link></li>
										<li className='fooli'><Link to="/tnpsc-coaching-centre-in-chennai">TNPSC, TRB, Police Exams & RRB</Link></li>
									</ul>
								</div>
								<div className="widget widget_nav_menu">
									<h4 className="widget-title">Admission & Payment</h4>
									<ul className="go-top fooul">
										<li className='fooli'><Link to="/online-payment">Online Payment</Link></li>
										<li className='fooli'><Link to="/rules-and-regulations">Rules and Regulations</Link></li>
										{/* <li className='fooli'><Link to="/">Application Form</Link></li>
										<li className='fooli'><Link to="/">Prospectus</Link></li> */}
										{/* <li className='fooli'><Link to="/">Rules and Regulations</Link></li> */}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-bottom">
					<div className="container">
						<div className="row clrwhite2">
							<div className="col-md-5 align-self-center clrWhite">
								<p className='clrWhite'>Copyright 2025 by MIET Education</p>
							</div>
							<div className="col-md-7 mt-md-0 mt-2">
								<p className='clrWhite'   style={{float:'right',paddingRight:60}}>Developed by<span><a href='https://bccmartech.com/' target="_blank"><img src={publicUrl + "assets/img/website/bccmartech.png"} width={'80px'}/></a></span></p>
							</div>
							
						</div>
					</div>
				</div>
			</footer>

		)
	}
}


export default Footer_v2